<p-menu #actionsMenu [popup]="true" [model]="multipleActionsMenuItems"></p-menu>

<p-table
  #dt
  [value]="data"
  [paginator]="paginator && !isWidgetTable"
  [rows]="currentRows"
  [first]="currentFirst"
  [totalRecords]="resolvedTotalRecords"
  (onPage)="onPageChange($event)"
  [styleClass]="isWidgetTable ? 'p-datatable ui-table-widget' : 'p-datatable'"
>
  <ng-template #caption>
    <div class="ui-table-caption">
      <ng-container *ngIf="isWidgetTable; else standardCaption">
        <div class="ui-table-widget-caption-left">
          <span class="text-2xl font-bold">{{ tableConfig.title }}</span>
        </div>

        <div class="ui-table-widget-caption-right">
          <p-button
            [label]="widgetRedirectLabel"
            icon="pi pi-external-link"
            iconPos="right"
            severity="secondary"
            [text]="true"
            styleClass="p-1 underline"
            (onClick)="onRedirectClick(tableConfig.redirectLink ?? '')"
          />
        </div>
      </ng-container>

      <ng-template #standardCaption>
        <div
          class="w-full flex flex-column md:flex-row align-items-end justify-content-between gap-2"
        >
          <span
            class="ui-table-search-field w-full md:w-20rem"
            *ngIf="tableConfig.searchVisible !== false"
          >
            <i class="pi pi-search ui-table-search-icon"></i>
            <input
              pInputText
              type="text"
              (input)="onGlobalFilter($event)"
              placeholder="Search keyword"
              class="w-full"
            />
          </span>

          <p-select
            *ngIf="rowsPerPageDropdownOptions.length"
            [options]="rowsPerPageDropdownOptions"
            [(ngModel)]="currentRows"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            styleClass="ui-table-page-size-dropdown"
            (onChange)="onRowsPerPageDropdownChange($event)"
          ></p-select>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <!-- `scope` lega l'intestazione alle celle della colonna, altrimenti un
           lettore di schermo legge valori senza sapere di cosa sono (WCAG 1.3.1).
           `aria-sort` annuncia l'ordinamento attivo (WCAG 4.1.2). -->
      <th
        *ngFor="let column of tableConfig.columns"
        scope="col"
        [class.sortable-column]="column.sortable !== false"
        [attr.aria-sort]="getAriaSort(column)"
      >
        <button
          *ngIf="column.sortable !== false"
          type="button"
          class="ui-table-sort-button"
          [attr.aria-label]="getSortActionLabel(column)"
          (click)="onColumnSortClick(column)"
        >
          <span>{{ column.header }}</span>
          <i [class]="getSortIconClass(column)" aria-hidden="true"></i>
        </button>
        <span *ngIf="column.sortable === false">{{ column.header }}</span>
      </th>
      <th *ngIf="tableConfig.actions.length" scope="col">
        <span class="sr-only">Azioni</span>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-rowData>
    <tr
      [class.ui-table-row-clickable]="rowClickable"
      [attr.tabindex]="rowClickable ? 0 : null"
      [attr.role]="rowClickable ? 'button' : null"
      (click)="onRowClick(rowData)"
      (keydown.enter)="onRowClick(rowData)"
      (keydown.space)="onRowClick(rowData)"
    >
      <td *ngFor="let column of tableConfig.columns">
        <ng-container *ngIf="column.type === 'tag'">
          <p-tag
            [value]="rowData[column.field]"
            [severity]="severityService.getSeverity(rowData[column.field]) ?? 'info'"
          ></p-tag>
        </ng-container>
        <ng-container *ngIf="column.type !== 'tag'">
          {{ rowData[column.field] }}
        </ng-container>
      </td>
      <td *ngIf="tableConfig.actions.length" class="ui-table-actions-cell">
        <div class="ui-table-actions">
          <ng-container *ngFor="let actionItem of singleActions">
            <p-button
              *ngIf="hasActionContent(actionItem)"
              [icon]="actionItem.icon || ''"
              [label]="actionItem.label || ''"
              [ariaLabel]="getActionAriaLabel(actionItem)"
              [severity]="actionItem.severity ?? null"
              [outlined]="actionItem.outlined ?? false"
              [text]="actionItem.text ?? false"
              [size]="actionItem.size ?? 'small'"
              [styleClass]="getSingleActionStyleClass(actionItem)"
              (onClick)="onSingleActionClick(actionItem, rowData)"
            ></p-button>
          </ng-container>

          <p-button
            *ngIf="multipleActions.length"
            icon="pi pi-ellipsis-v"
            ariaLabel="Altre azioni per questa riga"
            [outlined]="true"
            size="small"
            severity="secondary"
            styleClass="ui-table-action-menu-btn"
            (onClick)="openActionsMenu($event, rowData)"
          ></p-button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td [attr.colspan]="tableConfig.columns.length + (tableConfig.actions.length ? 1 : 0)">
        {{ emptyMessage }}
      </td>
    </tr>
  </ng-template>
</p-table>
